"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = __importDefault(require("../components/Field"));
var Label_1 = __importDefault(require("../components/Label"));
var IcoInputField_1 = __importDefault(require("./IcoInputField"));
var IcoField = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip, type = _a.type, icoValidation = _a.icoValidation, placeholder = _a.placeholder;
    return (react_1.default.createElement(Field_1.default, null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(IcoInputField_1.default, { name: name, size: size, readOnly: readOnly, toolTip: toolTip, type: type, icoValidation: icoValidation, placeholder: placeholder }))));
};
IcoField.defaultProps = {
    size: undefined,
    label: undefined,
    readOnly: false,
    toolTip: undefined,
    type: undefined,
    icoValidation: undefined,
    placeholder: undefined,
};
exports.default = IcoField;
